import { render, staticRenderFns } from "./VipService.vue?vue&type=template&id=ef06edaa&scoped=true"
import script from "./VipService.vue?vue&type=script&lang=js"
export * from "./VipService.vue?vue&type=script&lang=js"
import style0 from "./VipService.vue?vue&type=style&index=0&id=ef06edaa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef06edaa",
  null
  
)

export default component.exports